/* unplugin-vue-components disabled */import { render } from "./GcuAgreementScreen.vue?vue&type=template&id=478a56a7&scoped=true&ts=true"
import script from "./GcuAgreementScreen.vue?vue&type=script&lang=ts"
export * from "./GcuAgreementScreen.vue?vue&type=script&lang=ts"

import "./GcuAgreementScreen.vue?vue&type=style&index=0&id=478a56a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478a56a7"]])

export default __exports__